/** @format */

import React from 'react';
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import ArticleLayout from 'components/ArticleLayout';
import Container from 'react-bootstrap/Container';
import { LeadsSectionBody, LeadSources } from 'components/LeadsGenerator';
import { useLeadsSearch } from 'hooks/useLeadsSearch';
import { House, Building, LandPlot, TentTree, Tractor } from 'lucide-react';

import './styles.scss';

const PROPERTY_TYPES_SE = {
  House: 'Villa',
  LeisureHouse: 'Fritidshus',
  Plot: 'Tomt',
  Cottage: 'Villa',
  Farm: 'Gård',
  Apartment: 'Lägenhet'
};

const PropertyTypeIcon = ({ propertyType }) => {
  let Icon = () => {
    if (propertyType === 'House') {
      return <House width={12} height={12} />;
    }

    if (propertyType === 'Apartment') {
      return <Building width={12} height={12} />;
    }

    if (propertyType === 'Plot') {
      return <LandPlot width={12} height={12} />;
    }
    if (propertyType === 'LeisureHouse') {
      return <TentTree width={12} height={12} />;
    }
    if (propertyType === 'Farm') {
      return <Tractor width={12} height={12} />;
    }

    return <></>;
  };
  return (
    <div className='farm-card__icon'>
      <Icon />
    </div>
  );
};

export default function RenovationArticlePage(props) {
  const text = props.t('lang_registration:renovation_article');
  const { isMobileView } = props;

  const { leads, loading } = useLeadsSearch({
    page: 1
  });

  const PropertyCardsList = () => {
    const CardElement = ({
      propertyType,
      rooms,
      size,
      location,
      description
    }) => {
      return (
        <div className='farm-card'>
          <div className='farm-card__header'>
            <PropertyTypeIcon propertyType={propertyType} />

            <div className='farm-card__info'>
              <h2 className='farm-card__title'>
                {PROPERTY_TYPES_SE[propertyType]}
              </h2>
              <p className='farm-card__details'>
                {rooms} rum • {size} kvm storlek
              </p>
              <div className='farm-card__location'>
                <svg
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
                    fill='currentColor'
                  />
                </svg>
                {location}
              </div>
              {/* <div className='farm-card__sale'>
                <svg
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <rect
                    x='3'
                    y='6'
                    width='18'
                    height='15'
                    rx='2'
                    stroke='currentColor'
                    strokeWidth='2'
                  />
                  <path
                    d='M3 10h18M7 3v6M17 3v6'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                  />
                </svg>
                Sälj: Kommer att säljas inom de närmaste 6 månaderna
              </div> */}
              {/* <div className='farm-card__listed'>
                <svg
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M7 8l4 4 4-4'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                  <path
                    d='M7 12l4 4 4-4'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
                Listad: 8 september 2025 kl. 13:10(4 veckor sedan)
              </div> */}
            </div>

            {/* <div className='farm-card__status'>Pausad</div> */}
          </div>

          <div className='farm-card__bid'>
            <span className='farm-card__bid-label'>{description}</span>
            <span className='farm-card__bid-amount'>0 kr</span>
          </div>

          <div className='farm-card__actions'>
            {/* <button className='farm-card__button farm-card__button--paused'>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <rect
                  x='5'
                  y='4'
                  width='14'
                  height='18'
                  rx='2'
                  stroke='currentColor'
                  strokeWidth='2'
                />
                <path
                  d='M12 8v8M8 12h8'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                />
              </svg>
              Pausad
            </button> */}
            <button className='farm-card__button farm-card__button--buy'>
              <svg
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M8 12h8M12 8v8'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                />
              </svg>
              Vill köpa?
            </button>
          </div>
        </div>
      );
    };

    return (
      <div className='property-card-list'>
        {!loading &&
          leads.map((leadData, index) => (
            <CardElement
              key={index}
              propertyType={leadData.extra?.propertyTypes[0]}
              location={leadData.location}
              description={leadData.details}
              rooms={leadData.extra?.numberOfRooms}
              size={leadData.extra?.sqMeters}
            />
          ))}
      </div>
    );
  };

  return (
    <>
      <div className='main-container renovation-article-page-container'>
        <Header {...props} />
        <div className='inner-container'>
          <Container>
            {/* Page content here */}
            <ArticleLayout
              text={text}
              isMobileView={isMobileView}
              banner={'images/renovation-top.png'}
              subIcon={'images/renovation-middle.png'}
              subIcon1={'images/renovation-bottom.png'}
              showFocusButtons={true}
              SpecialSection={PropertyCardsList}>
              <LeadsSectionBody
                metadata={{
                  source: LeadSources.FM_RENOVATION
                }}
                showPropertyTypes={true}
                showUrgency={true}
                showTextInputs={true}
                showLeadTypes={true}
                showSquareMeterInput={true}
                showNumberOfRoomsInput={true}
                showAddressInput={true}
                showBrokerStatusSelector={true}
                {...props}
              />
            </ArticleLayout>
          </Container>
        </div>

        <Footer {...props} />
      </div>
    </>
  );
}
